import React from 'react'
import Icon from '../misc/Icons'

class EditorInsertButton extends React.Component{

	render(){

		const {label, icon, isLocked, onClickFunction}=this.props
			
		return(
			<div className={'itemEditor-insertMenuButton' + (isLocked ? ' itemEditor-insertMenuButton--isLocked':'')} onClick={onClickFunction}>
				<div className='itemEditor-insertMenuButton-icon'>
					<Icon name={icon} />
					<Icon name='squircle' />					
				</div>
				<div className='itemEditor-insertMenuButton-label'>
					{label}
				</div>
			</div>
		)
	}
}

export default EditorInsertButton

